import { TabProps, TabGroupProps } from "@/types/component"

import "./index.scss"

import { t } from "i18next"
import React, { useState, useRef, useLayoutEffect } from "react"

const Tab: React.FC<TabProps> = ({ isActive, label, onClick }) => {
  return (
    <div className={`tab ${isActive ? "active" : ""}`} onClick={onClick}>
      {label}
    </div>
  )
}

const TabGroup: React.FC<TabGroupProps> = ({ activeTab: controlledActiveTab, defaultActiveTab = 0, onTabChange, orientation = "horizontal", fullWidth = false, tabs }) => {
  const [internalActiveTab, setInternalActiveTab] = useState(defaultActiveTab)
  const isControlled = controlledActiveTab !== undefined
  const activeTab = isControlled ? controlledActiveTab : internalActiveTab
  const [underlineStyle, setUnderlineStyle] = useState({ width: 0, left: 0 })
  const tabListRef = useRef<HTMLDivElement>(null)

  const handleTabClick = (index: number) => {
    if (!isControlled) setInternalActiveTab(index)
    if (onTabChange) {
      onTabChange(index)
    }
  }

  useLayoutEffect(() => {
    if (orientation === "horizontal" && tabListRef.current) {
      const timer = setTimeout(() => {
        const tabElements = Array.from(tabListRef.current!.children).filter(child => 
          !child.classList.contains('sliding-underline')
        ) as HTMLElement[]
        
        const activeTabElement = tabElements[activeTab]
        if (activeTabElement) {
          const { offsetWidth, offsetLeft } = activeTabElement
          setUnderlineStyle({
            width: offsetWidth,
            left: offsetLeft
          })
        }
      }, 1)

      return () => clearTimeout(timer)
    }
  }, [activeTab, orientation, tabs])

  return (
    <div className={`tab-group ${orientation} ${fullWidth ? 'full-width' : ''}`}>
      <div className="tab-list" ref={tabListRef}>
        {orientation === "horizontal" && (
          <div 
            className="sliding-underline"
            style={{
              width: `${underlineStyle.width}px`,
              transform: `translateX(${underlineStyle.left}px)`,
              transition: underlineStyle.width > 0 ? 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)' : 'none'
            }}
          />
        )}
        {tabs.map((tab, index) => (
          <Tab
            isActive={index === activeTab}
            key={typeof tab.label === "string" ? tab.label : `tab-${index}`}
            label={t(tab.label)}
            onClick={() => handleTabClick(index)}
          />
        ))}
      </div>
    </div>
  )
}

export default TabGroup
